<template>
    <el-table :data="tableData" style="width: 100%;max-height:94%" height="94%" v-loading="loading">
          <el-table-column prop="loopName" label="名称"> </el-table-column>
          <el-table-column label="本月">
            <el-table-column label="用电量(kwh)" prop="sum">
              <template slot-scope="scope">{{scope.row.sum.toFixed(2)}}</template>
            </el-table-column>
            <el-table-column label="用电占比" prop="proportion">
              <template slot-scope="scope"> {{ scope.row.proportion=='NaN'?'--':floatFormat(scope.row.proportion*100,2)+'%' }} </template>
            </el-table-column>
            <el-table-column label="用电排行" prop="todayIndex"
              ><template slot-scope="scope">
                {{ scope.row.todayIndex }}
                <span v-if="scope.row.order == 'up'"
                  ><img src="../../../assets/img/up.png" width="15"
                style="vertical-align: -2px;"/></span>
                <span v-else-if="scope.row.isdown == 'down'"
                  ><img src="../../../assets/img/down.png" width="15"
                style="vertical-align: -2px;"/></span>
                <span v-else
                  ><img src="../../../assets/img/jian.png" width="10"
                style="margin-left:3px"/></span> </template
            ></el-table-column>
          </el-table-column>
          <el-table-column prop="province" label="上月">
            <el-table-column prop="lastMonthSum" label="用电量(kwh)">
              <template slot-scope="scope"> {{ scope.row.lastMonthSum=='NaN'?'--':floatFormat(scope.row.lastMonthSum,2) }} </template>
            </el-table-column>
            <el-table-column label="用电占比" prop="lastMonthProportion"> 
              <template slot-scope="scope"> {{ scope.row.lastMonthProportion=='NaN'?'--':floatFormat(scope.row.lastMonthProportion*100,2)+"%" }} </template>
            </el-table-column>
            <el-table-column label="用电排行" prop="lastMonthIndex">
                <template slot-scope="scope">
                {{ scope.row.lastMonthIndex }}
                <span v-if="scope.row.isdown == '0'"
                  ><img src="../../../assets/img/up.png" width="15"
                style="vertical-align: -2px;"/></span>
                <span v-else-if="scope.row.isdown == '1'"
                  ><img src="../../../assets/img/down.png" width="15"
               style="vertical-align: -2px;" /></span>
                <span v-else-if="scope.row.isdown == '2'"
                  ><img src="../../../assets/img/jian.png" width="10"
                style="margin-left:3px"/></span> </template>    
             </el-table-column>
          </el-table-column>
        </el-table>
</template>

<script>
import {
    powerRankings
} from "../../../api/power";
import {
  floatFormat
} from "../../../util/MathUtil";
export default {
  components: {
    
  },
  props:{
    tableData:Array,
    loading:Boolean
  },
  data() {
    return {
      date: new Date(),
      // tableData:[],
    };
  },
  computed: {
    
  },
  mounted(){
    // this.getLooplist();
  },
  methods:{
    floatFormat,
    getLooplist(){
        powerRankings(this.date).then((res) => {
          this.tableData = res.data.data.list || [];
        });
        
    },
  }
};
</script>
